// Author: Shubham Sonkar

// Import necessary dependencies and styles
import React, { useState, useReducer, Suspense } from "react";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { useSetting } from "../hooks/Hooks";
import Skeleton from "@mui/material/Skeleton";
import CryptoJS from "crypto-js";
import { IdleTimerProvider } from "react-idle-timer";
// import { useQuery } from "react-query";
import { CheckUserLogin, logout } from "../hooks/Auth/Authentication";
import { CustomModal } from "../components/CustomModal/CustomModal";
import IdleImg from "./../assets/Image/idle.png";
import { Button } from "@mui/material";
import Cookies from "js-cookie";
// import { onMessageListener, messaging } from "./firebase";
// import { getToken } from "firebase/messaging";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { CustomDescription, CustomHeading } from "../components/Common/Common";
import { setDispatchDashboard } from "../hooks/Function";


// Define the Main component
const Main = () => {
  // Retrieve globalData from useSetting hook
  const { globalData } = useSetting();

  const [idleModal, setIdleModal] = useState(false);
  const [leadModal, setLeadModal] = useState(false);

  // Set initial state for myglobalData
  const [myglobalData, setMyglobalData] = React.useState(globalData);
  // Styled component for DrawerHeader
  const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    ...theme.mixins.toolbar,
  }));

  // ======================================================================================================
  // Notification
  const [token, setToken] = React.useState("");
  const [notification, setNotification] = React.useState({
    title: "",
    body: "",
  });

  // const requestForToken = async () => {
  //   try {
  //     const currentToken = await getToken(messaging, {
  //       vapidKey: process.env.REACT_APP_VAPID_KEY,
  //     });
  //     if (currentToken) {
  //       console.log("current token for client: ", currentToken);
  //       setToken(currentToken);
  //     } else {
  //       // Show permission request UI
  //       console.log(
  //         "No registration token available. Request permission to generate one."
  //       );
  //     }
  //     // const res = undefined;
  //     // console.log(res);
  //   } catch (err) {
  //     setToken("notificationblocked");
  //   }
  // };

  // React.useEffect(() => {
  //   if (!notification?.title) {
  //     requestForToken();
  //   } else {
  //     console.log("Background Message");
  //   }
  // }, []);

  // onMessageListener()
  //   .then((payload) => {
  //     toast.success(
  //       <div>
  //         <CustomHeading
  //           Heading={payload.notification.title}
  //           style={{ fontSize: "14px" }}
  //         />
  //         <CustomDescription Description={payload.notification.body} />
  //       </div>,
  //       {
  //         position: toast.POSITION.BOTTOM_RIGHT,
  //         icon: false,
  //       }
  //     );
  //     // const { data: { icon } } = payload;
  //     setNotification({
  //       title: payload?.notification?.title,
  //       body: payload?.notification?.body,
  //     });
  //     // new Notification(title, { body, icon: CRMLogo });
  //   })
  //   .catch((err) => console.log("failed: ", err));
  // ======================================================================================================

  // State for app startup and loading
  const [appInitialised, setAppInitialised] = useState(false);
  const [loading, setLoading] = React.useState(true);

  // Function to load default screen on app startup
  function loadDefault() {
    console.log("load default");
    if (appInitialised === false) {
      // check last active screen from local storage
      if (localStorage.getItem("currScreen") !== null) {
        // Set default screen to Login if not found
        if (
          localStorage.getItem("currScreen").length === 0 ||
          localStorage.getItem("currScreen") === ""
        ) {
          localStorage.setItem("currScreen", "Login");
        }
        let currScreen = localStorage.getItem("currScreen");
        dispatch({ event: currScreen });
      } else {
        // Set default screen to Login if no previous screen found
        dispatch({ event: "Login" });
      }
    }
  }

  // Function to encrypt and set data in local storage
  function setLocalData(key, value) {
    let CryptoJSKey = globalData.CompanyName + "@" + globalData.Version;
    var user_data = CryptoJS.AES.encrypt(value, CryptoJSKey).toString();
    localStorage.setItem(key, user_data);
  }

  function setLocalPage(key, value) {
    localStorage.setItem(key, value);
  }

  function setLocalPageSize(key, value) {
      localStorage.setItem(key, value);
  }

  // const LoginCheck = useQuery("logincheck", () => {
  //   return CheckUserLogin();
  // });

  // Mapping of event names to corresponding components
  const componentConfig = {
    // Map event names to their corresponding components
    Login: myglobalData.login.path,
    register: myglobalData.register.path,
    verifyotp: myglobalData.verifyotp.path,
    changepassword: myglobalData.pages.changepassword,
    forgotpassword: myglobalData.pages.forgotpassword,
    somethingWentWrong: myglobalData.pages.somethingWentWrong,

    dashboard: myglobalData.pages.dashboard,
    subdashboard: myglobalData.pages.subdashboard,

    addemployee: myglobalData.pages.employee.addemployee,
    editemployee: myglobalData.pages.employee.editemployee,
    viewemployee: myglobalData.pages.employee.viewemployee,
    employeedetails: myglobalData.pages.employee.employeedetails,
    
    addcustomer: myglobalData.pages.customer.addcustomer,
    editcustomer: myglobalData.pages.customer.editcustomer,
    viewcustomer: myglobalData.pages.customer.viewcustomer,
    customerdetails: myglobalData.pages.customer.customerdetails,

    addcustomertype: myglobalData.pages.customertype.addcustomertype,
    editcustomertype: myglobalData.pages.customertype.editcustomertype,
    viewcustomertype: myglobalData.pages.customertype.viewcustomertype,
    customertype: myglobalData.pages.customertype.customertype,

    addproduct: myglobalData.pages.product.addproduct,
    editproduct: myglobalData.pages.product.editproduct,
    viewproduct: myglobalData.pages.product.viewproduct,
    productdetails: myglobalData.pages.product.productdetails,
    
    addproductclientrates: myglobalData.pages.productclientrates.addproductclientrates,
    editproductclientrates: myglobalData.pages.productclientrates.editproductclientrates,
    viewproductclientrates: myglobalData.pages.productclientrates.viewproductclientrates,
    productclientrates: myglobalData.pages.productclientrates.productclientrates,

    addproductbrand: myglobalData.pages.productbrand.addproductbrand,
    editproductbrand: myglobalData.pages.productbrand.editproductbrand,
    viewproductbrand: myglobalData.pages.productbrand.viewproductbrand,
    productbrand: myglobalData.pages.productbrand.productbrand,

    sizeunits: myglobalData.pages.sizeunits.sizeunits,
    addsizeunit: myglobalData.pages.sizeunits.addsizeunit,
    editsizeunit: myglobalData.pages.sizeunits.editsizeunit,
    viewsizeunit: myglobalData.pages.sizeunits.viewsizeunit,

    hsncode: myglobalData.pages.hsncode.hsncode,
    addhsncode: myglobalData.pages.hsncode.addhsncode,
    edithsncode: myglobalData.pages.hsncode.edithsncode,
    viewhsncode: myglobalData.pages.hsncode.viewhsncode,
    
    adduser: myglobalData.pages.user.adduser,
    edituser: myglobalData.pages.user.edituser,
    viewuser: myglobalData.pages.user.viewuser,
    userdetails: myglobalData.pages.user.userdetails,
    
    addrequirement: myglobalData.pages.requirement.addrequirement,
    editrequirement: myglobalData.pages.requirement.editrequirement,
    quickeditrequirement: myglobalData.pages.requirement.quickeditrequirement,
    viewrequirement: myglobalData.pages.requirement.viewrequirement,
    editrequirementproduct: myglobalData.pages.requirement.editrequirementproduct,
    requirementdetails: myglobalData.pages.requirement.requirementdetails,
    
    editinvoice: myglobalData.pages.invoice.editinvoice,
    invoicedetails: myglobalData.pages.invoice.invoicedetails,
    viewinvoice: myglobalData.pages.invoice.viewinvoice,
    taxinvoicedetails: myglobalData.pages.invoice.taxinvoicedetails,
    edittaxinvoice: myglobalData.pages.invoice.edittaxinvoice,
    quickedittaxinvoice: myglobalData.pages.invoice.quickedittaxinvoice,
    viewtaxinvoice: myglobalData.pages.invoice.viewtaxinvoice,
    viewchallaninvoice: myglobalData.pages.invoice.viewchallaninvoice,

    einvoicedetails: myglobalData.pages.einvoice.einvoicedetails,
    generateirn: myglobalData.pages.einvoice.generateirn,
    cancelirn: myglobalData.pages.einvoice.cancelirn,
    vieweinvoice: myglobalData.pages.einvoice.vieweinvoice,
    einvoiceprint: myglobalData.pages.einvoice.einvoiceprint,
    generateewaybill: myglobalData.pages.einvoice.generateewaybill,
    viewewaybill: myglobalData.pages.einvoice.viewewaybill,

    addgstno: myglobalData.pages.gstno.addgstno,
    editgstno: myglobalData.pages.gstno.editgstno,
    viewgstno: myglobalData.pages.gstno.viewgstno,
    gstnodetails: myglobalData.pages.gstno.gstnodetails,

    invoicechargesdetails: myglobalData.pages.invoicecharges.invoicechargesdetails,
    addinvoicecharges: myglobalData.pages.invoicecharges.addinvoicecharges,
    editinvoicecharges: myglobalData.pages.invoicecharges.editinvoicecharges,
    viewinvoicecharges: myglobalData.pages.invoicecharges.viewinvoicecharges,

    bankaccounts: myglobalData.pages.bankaccount.bankaccounts,
    addbankaccount: myglobalData.pages.bankaccount.addbankaccount,
    editbankaccount: myglobalData.pages.bankaccount.editbankaccount,
    viewbankaccount: myglobalData.pages.bankaccount.viewbankaccount,

    templates: myglobalData.pages.email.templates,
    addTemplate: myglobalData.pages.email.addTemplate,
    editTemplate: myglobalData.pages.email.editTemplate,
    viewTemplate: myglobalData.pages.email.viewTemplate,

    profile: myglobalData.pages.other.profile,
    crmsetting: myglobalData.pages.other.crmsetting,
    loader: myglobalData.pages.other.loader,
    
    purchaseorderdetails:myglobalData.pages.purchaseorder.purchaseorderdetails,
    addpurchaseorder:myglobalData.pages.purchaseorder.addpurchaseorder,
    editpurchaseorder:myglobalData.pages.purchaseorder.editpurchaseorder,
    viewpurchaseorder:myglobalData.pages.purchaseorder.viewpurchaseorder,

    addsamplekits: myglobalData.pages.samplekits.addsamplekits,
    editsamplekits: myglobalData.pages.samplekits.editsamplekits,
    viewsamplekits: myglobalData.pages.samplekits.viewsamplekits,
    samplekitsdetails: myglobalData.pages.samplekits.samplekitsdetails,

    addsamples: myglobalData.pages.samples.addsamples,
    editsamples: myglobalData.pages.samples.editsamples,
    viewsamples: myglobalData.pages.samples.viewsamples,
    samplesdetails: myglobalData.pages.samples.samplesdetails,

    inventorydetails:myglobalData.pages.inventory.inventorydetails,
    addinventory:myglobalData.pages.inventory.addinventory,
    editinventory:myglobalData.pages.inventory.editinventory,
    viewinventory:myglobalData.pages.inventory.viewinventory,
    
    productreport: myglobalData.pages.report.productreport,
    
    auditdetails: myglobalData.pages.audit.auditdetails,
  };

  // Reducer for navigation state
  function navReducer(state, action) {
    const tempData = { ...myglobalData };
    
    // Handle special events and update global data accordingly
    if (action.event === "sotre_search_data") {
      setLocalData("sotre_search_data", action.data);
    } else if (action.event === "updateglobal_userdata") {
      setLocalData("updateglobal_userdata", action.data);
      tempData.user_data = action.data;
      setMyglobalData(tempData);
    } else if (action.event === "store_new_data") {
      setLocalData("store_new_data", action.data);
    } else if (action.event === "setlocaldata") {
      setLocalData(action.key, action.value);
    } else if (action.event === "setpagination") {
      setLocalPage(action.key, action.data);
    } else if (action.event === "setpagesize") {
        setLocalPageSize(action.key, action.data);
    } else {
      // Handle regular navigation events
      const component = componentConfig[action.event];
      if (component) {
        // Update current and previous screen in local storage
        localStorage.setItem(
          "previousScreen",
          localStorage.getItem("currScreen")
        );
        setTimeout(() => {
          localStorage.setItem("currScreen", action.event);
          tempData.currScreen = component;
          setMyglobalData(tempData);
        }, 1);
      } else {
        console.log("No action");
      }
    }
  }
  // UseReducer hook for navigation
  const [state, dispatch] = useReducer(navReducer);

  React.useEffect(() => {
    setDispatchDashboard(dispatch);
    // Perform initialization on app startup
    if (appInitialised === false) {
      setAppInitialised(true);
      // if (!LoginCheck.isLoading) {
      //   if (LoginCheck.data?.data == "Session found") {
      loadDefault();
      // } else {
      //   dispatch({ event: "Login" });
      // }
      // }
    }
    // Set loading to false after a short delay
    setTimeout(() => {
      setLoading(false);
    }, 10);
  }, []);

  const logout_User = () => {
    logout(Cookies.get("token"))
      .then((response) => {
        if (response.data === "Logout Done") {
          dispatch({ event: "Login" });
          setIdleModal(false);
          setTimeout(() => {
            Cookies.remove("user", { path: "/", domain: globalData.URL });
            Cookies.remove("type", { path: "/", domain: globalData.URL });
            Cookies.remove("role", { path: "/", domain: globalData.URL });
            Cookies.remove("username", { path: "/", domain: globalData.URL });
            Cookies.remove("module_privilege", {
              path: "/",
              domain: globalData.URL,
            });
          }, 10);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return !loading ? (
    <>
      {appInitialised && (
        <Suspense
          callback={console.log("Loading...")}
          fallback={
              localStorage.getItem("currScreen") === "Login" ? null : localStorage.getItem("currScreen") === "register" ? null : localStorage.getItem("currScreen") === "verifyotp" ? null : localStorage.getItem("currScreen") ===
              "forgotpassword" ? null : (
              <Box sx={{ display: "flex" }}>
                <myglobalData.pages.components.leftsidebar
                  dispatch={dispatch}
                  myglobalData={myglobalData}
                />
                <DrawerHeader />
                <Box component="main" sx={{ flexGrow: 1, px: 3, py: 10 }}>
                  <Skeleton variant="rectangular" width="100%" height={30} />
                  <Skeleton
                    variant="rounded"
                    width="100%"
                    height={300}
                    sx={{ mt: 3 }}
                  />
                  <Skeleton
                    variant="rounded"
                    width="100%"
                    height={300}
                    sx={{ mt: 3 }}
                  />
                </Box>
              </Box>
            )
          }
        >
          {/* <button onClick={notify}>Notify!</button> */}
          <ToastContainer />
          <CustomModal
            show={idleModal}
            hideCloseIcon={true}
            ModalBody={
              <Box className="text-center card-bg p-3">
                <img src={IdleImg} alt="Idle" className="w-75 mb-3" />
                <h5 className="text-danger mb-2" style={{ fontSize: "22px" }}>
                  You have been idle for too long time!
                </h5>
                <p
                  className="text-muted w-75 m-auto"
                  style={{ fontSize: "13px" }}
                >
                  would you like to stay logged in? Please respond with a Leave
                  or continue to use the application.
                </p>
                <div className="mt-3">
                  <Button onClick={logout_User} className="idle-leave-btn">
                    Leave
                  </Button>
                  <Button
                    onClick={() => setIdleModal(false)}
                    className="idle-continue-btn"
                  >
                    continue
                  </Button>
                </div>
              </Box>
            }
          />
          <CustomModal
            show={leadModal}
            ModalSize="lg"
            onHide={() => setLeadModal(false)}
            showHeader={true}
            ModalTitle="Update Lead Status"
            ModalBody={<h1>hello world</h1>}
            // ModalBody={<LeadDeatils data={leadData} />}
          />
          {localStorage.getItem("currScreen") === "Login" ? (
            <myglobalData.currScreen
              dispatch={dispatch}
              myglobalData={myglobalData}
              token={token}
            />
          ) : localStorage.getItem("currScreen") === "register" ? (
            <myglobalData.currScreen
              dispatch={dispatch}
              myglobalData={myglobalData}
              token={token}
            />  
          ) : localStorage.getItem("currScreen") === "verifyotp" ? (
            <myglobalData.currScreen
              dispatch={dispatch}
              myglobalData={myglobalData}
              token={token}
            />
          ) : localStorage.getItem("currScreen") === "forgotpassword" ? (
            <myglobalData.currScreen
              dispatch={dispatch}
              myglobalData={myglobalData}
              token={token}
            />    
          ) : localStorage.getItem("currScreen") === "loader" ? (
            <myglobalData.currScreen
              dispatch={dispatch}
              myglobalData={myglobalData}
            />
          ) : (
            <IdleTimerProvider
              // timeout={1000 * 15}
              timeout={1000 * 60 * 15}
              onIdle={() => setIdleModal(true)}
            >
              <Box style={{ display: "flex" }}>
                <myglobalData.pages.components.leftsidebar
                  dispatch={dispatch}
                  myglobalData={myglobalData}
                />
                <DrawerHeader />
                <Box
                  component="main"
                  sx={{ flexGrow: 1, px: 3, py: 10, overflowX: "hidden" }}
                >
                  <myglobalData.currScreen
                    dispatch={dispatch}
                    myglobalData={myglobalData}
                  />
                </Box>
              </Box>
            </IdleTimerProvider>
          )}
        </Suspense>
      )}
    </>
  ) : (
    <div className="center-body" id="spinner">
      <img src="./logo_loader.gif" alt="loader" srcSet="./logo_loader.gif" width="30%" />
    </div>
  );
};

export default Main;
